import React from 'react'
import Icon from '../../Icon2/Icon'
import Button from '../../Button/Button'
const BulkActionAlertBanner = ({ alertInfoBannerDetails }) => {
  // Add some message as fallback while checking on storybook like this ["Action Limit Reached", " The 'Unpublish' action limited to 10 and 'Publish' action limited to 10 entries. You can perform other bulk actions on up to 20 records."]
  const messageHasHeaderAndDetails = alertInfoBannerDetails?.message?.split(":").length == 2;
  const [heading, details] = messageHasHeaderAndDetails ? alertInfoBannerDetails?.message.split(":") : [null, alertInfoBannerDetails?.message];

  // "secondary" variant: white background, left-aligned (flex-start) instead of space-between, and no
  // dismiss/close icon. Other variants (e.g. "info") keep the default space-between layout + close icon.
  const isSecondary = alertInfoBannerDetails?.bannerType === "secondary";
  const bannerClassNames = [
    "bulk_action_alert_banner",
    alertInfoBannerDetails?.bannerType || "",
    isSecondary ? "flex-start" : "flex-justify",
    "flex-v-center",
    alertInfoBannerDetails?.className || ""
  ].filter(Boolean).join(" ");

  const bannerActionClassName = [
    isSecondary ? "flex-start" : "flex-center",
    "flex-v-center banner_actions mr-20"
  ].filter(Boolean).join(" ");

  return (
    <div className={bannerClassNames} data-test-id="cs-table-info-banner">
      <div className="bulk_action_alert_banner-message font-size-large ml-20 lh-default" data-test-id="cs-table-info-banner-message">
        {heading && !isSecondary ? <span className="font-semi-bold">{heading}:</span> : null}
        {details ? <span className="font-regular">{details}</span> : null}
      </div>
      <div className={bannerActionClassName} data-test-id="cs-table-info-banner-actions">
        {alertInfoBannerDetails?.onDontShowAgain ? <span className="bulk_action_alert_banner-dont_show_again font-size-large font-semi-bold mr-10" onClick={alertInfoBannerDetails?.onDontShowAgain} >Don't show this again</span> : null}
        {alertInfoBannerDetails?.onAction ? <Button buttonType="tertiary" version='v2' className="bulk_action_alert_banner-action_button font-size-large font-semi-bold mr-10" onClick={alertInfoBannerDetails?.onAction} testId="cs-table-info-banner-action-text">{alertInfoBannerDetails?.actionText}</Button> : null}
        {!isSecondary ? (
          <span className='close-icon' onClick={alertInfoBannerDetails?.onDimnish} data-test-id="cs-table-info-banner-close-icon">
            <Icon version="v2" icon="CloseNoborder" size="medium" />
          </span>
        ) : null}
      </div>
    </div>
  )
}

export default BulkActionAlertBanner